import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { getMockApplicantDocuments } from '../../../../../RentalPortalApplicant'
import { RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT } from '../../../../RentalPortal.constants'
import { APPLICANT_DOCUMENTS_PAGE_SIZE } from '../../RentalPortalApplicantProfileDocuments.constants'

export function useApplicantProfileDocuments({ applicantId }) {
  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function loadDocuments() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    getMockApplicantDocuments({
      applicant_id: applicantId,
      page,
      page_size: APPLICANT_DOCUMENTS_PAGE_SIZE,
    })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)
          setLoading(false)
          setInitiated(true)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (applicantId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      loadDocuments()
    }
  }, [applicantId, page, reloadKey])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    handleRefresh,
    handleSetPagination,
    hasError,
    isInitiated,
    isLoading,
    items: response?.results?.objects ?? EMPTY_LIST,
    pagination: {
      count: response?.pagination?.total ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      page,
      pageCount:
        response?.pagination?.page_count ?? RENTAL_PORTAL_PAGE_READ_EMPTY_COUNT,
      pageSize: APPLICANT_DOCUMENTS_PAGE_SIZE,
    },
  }
}
